export default __webpack_public_path__ + "static/media/logo-new 2.314030f9.png";